/* eslint-disable react/destructuring-assignment */
import { DataGrid, DataGridProps } from '@mui/x-data-grid'

import { Grid, Sx } from './Table.styles'
import { useMemo } from 'react'

export interface TableProps extends DataGridProps {
  height?: number
}

export default function Table(props: TableProps) {
  const parsedProps = useMemo(() => {
    const parsedRows = props.rows.map((prop) => {
      const propositionBuffer = prop

      if (!prop.rapporteur) propositionBuffer.rapporteur = ''
      if (!prop.rapporteurParty) propositionBuffer.rapporteurParty = ''
      if (!prop.rapporteurUf) propositionBuffer.rapporteurUf = ''

      const lastRapporteur = prop.rapporteur.split(',').at(-1).trim()
      const lastRapporteurParty = prop.rapporteurParty.split(',').at(-1).trim()
      const lastRapporteurUf = prop.rapporteurUf.split(',').at(-1).trim()

      propositionBuffer.rapporteur = lastRapporteur
      propositionBuffer.rapporteurParty = lastRapporteurParty
      propositionBuffer.rapporteurUf = lastRapporteurUf

      return propositionBuffer
    })

    return {
      ...props,
      rows: parsedRows,
    }
  }, [props.rows])

  return (
    <Grid height={props.height}>
      <DataGrid
        sx={{ ...Sx, ...props.sx }}
        {...parsedProps}
        componentsProps={{
          pagination: {
            labelRowsPerPage: 'Linhas por página',
          },
        }}
      />
    </Grid>
  )
}
